(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2298);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _loadable = _interop_require_default(__webpack_require__(4588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 3644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 4588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(7294));
var _loadableContext = __webpack_require__(3644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 4264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const FAQs = (props)=>{
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const contentRefs = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)([]);
    const faqs = props === null || props === void 0 ? void 0 : props.faqsData;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        contentRefs.current = contentRefs.current.slice(0, faqs.length);
    }, [
        faqs
    ]);
    const toggleAccordion = (index)=>{
        setOpenIndex(openIndex === index ? null : index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "destination_faqs row justify-content-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "col-12 col-sm-12 col-md-8 col-lg-8",
            children: faqs.map((item, index)=>{
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "accordion",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "accordion__title",
                            onClick: ()=>toggleAccordion(index),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                                    children: [
                                        " ",
                                        item.accordionQuestion
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "accordion_btn",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "arrow_btn ".concat(openIndex === index ? "rotate" : ""),
                                        "aria-label": "Accordion Button",
                                        children: openIndex === index ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "20px",
                                            viewBox: "0 -960 960 960",
                                            width: "20px",
                                            fill: "#000000",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M232-444v-72h496v72H232Z"
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "24px",
                                            viewBox: "0 -960 960 960",
                                            width: "20px",
                                            fill: "#000000",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                d: "M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            ref: (el)=>contentRefs.current[index] = el,
                            className: "accordion__content ".concat(openIndex === index ? "accordion__content--open" : ""),
                            style: openIndex === index ? {
                                maxHeight: contentRefs.current[index] ? contentRefs.current[index].scrollHeight : "none"
                            } : {
                                maxHeight: 0
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: item.accordionAnswer
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(FAQs));


/***/ }),

/***/ 9881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const BreadCrumbSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org/",
                    "@type": "BreadcrumbList",
                    "itemListElement": [
                        {
                            "@type": "ListItem",
                            "position": 1,
                            "name": "About Us",
                            "item": "https://www.hoteltwintowers.com/about-us"
                        },
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": "Room and Suits",
                            "item": "https://www.hoteltwintowers.com/hotel-room-in-shimla"
                        },
                        {
                            "@type": "ListItem",
                            "position": 3,
                            "name": "Bar and Restaurant",
                            "item": "https://www.hoteltwintowers.com/bar-and-restaurant"
                        },
                        {
                            "@type": "ListItem",
                            "position": 4,
                            "name": "Events",
                            "item": "https://www.hoteltwintowers.com/#events"
                        },
                        {
                            "@type": "ListItem",
                            "position": 5,
                            "name": "Banquet Halls in Shimla",
                            "item": "https://www.hoteltwintowers.com/banquet-halls-in-shimla"
                        },
                        {
                            "@type": "ListItem",
                            "position": 6,
                            "name": "Conference Halls",
                            "item": "https://www.hoteltwintowers.com/conference-hall"
                        }
                    ]
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbSchema);


/***/ }),

/***/ 1058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const HotelSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "http://schema.org",
                    "@type": "Hotel",
                    "name": "The Twin Towers Hotel",
                    "alternateName": "If Known by Another Shorter Name",
                    "url": "https://hoteltwintowers.com/",
                    "logo": "https://www.hoteltwintowers.com/icons/header-logo.svg",
                    "image": "https://www.hoteltwintowers.com/images/home-banner.png",
                    "description": "One of the best hotel in Kufri, it is located in the heart of town, amid the Himalayan foothills. The location is a beautiful retreat in a mountainous neighborhood, offering visitors a tranquil, calm, and pleasant atmosphere for a soul-filling holiday, and being so near to nature offers a choice of activities that will nourish your spirit. It will undoubtedly assist you in unwinding while you participate in the most exciting activities with your loved ones at and around the resort, since it is a great site for fun activities such as adventure sports, walks and trails, and so on.",
                    "sameAs": [
                        "https://www.facebook.com/twintower.hotel/",
                        "https://www.instagram.com/hotel_twintowers/",
                        "https://www.linkedin.com/in/the-twin-towers-hotel/"
                    ],
                    "telephone": "+91 07807885113",
                    "email": "info@hoteltwintowers.com",
                    "hasMap": "https://goo.gl/maps/GzserDhdgJJFburx5",
                    "checkinTime": "14:00",
                    "checkoutTime": "12:00",
                    "additionalType": "",
                    "areaServed": "",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "NH 05, New kufri,",
                        "addressLocality": "Galu, Hills,",
                        "addressRegion": "Shimla",
                        "postalCode": "171209",
                        "addressCountry": "India"
                    },
                    "priceRange": "$$$",
                    "starRating": {
                        "@type": "http://schema.org/Rating",
                        "ratingValue": "5"
                    }
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (HotelSchema);


/***/ }),

/***/ 8360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const LocalBusinessSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": "LocalBusiness",
                    "name": "The Twin Towers Hotel",
                    "image": "https://www.hoteltwintowers.com/images/home-banner.png",
                    "@id": "",
                    "url": "https://hoteltwintowers.com/",
                    "telephone": "+91 07807885113",
                    "priceRange": "$$$",
                    "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "NH 05, New kufri, Galu, Hills",
                        "addressLocality": "Shimla",
                        "postalCode": "171209",
                        "addressCountry": "IN"
                    },
                    "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 31.0891785,
                        "longitude": 77.28672519999999
                    },
                    "sameAs": [
                        "https://www.facebook.com/twintower.hotel/",
                        "https://www.instagram.com/hotel_twintowers/",
                        "https://www.linkedin.com/in/the-twin-towers-hotel/"
                    ]
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (LocalBusinessSchema);


/***/ }),

/***/ 6601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const LodgingReservationSchema = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
            type: "application/ld+json",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify({
                    "@context": "http://schema.org",
                    "@type": "LodgingReservation",
                    "reservationNumber": "",
                    "reservationStatus": "http://schema.org/Confirmed",
                    "underName": {
                        "@type": "Person",
                        "name": "John Smith"
                    },
                    "reservationFor": {
                        "@type": "LodgingBusiness",
                        "name": "The Twin Towers Hotel",
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "NH 05, New kufri, Galu, Hills",
                            "addressLocality": "Shimla",
                            "addressRegion": "Indian Himalayan Region",
                            "postalCode": "171209",
                            "addressCountry": "IN"
                        },
                        "telephone": "07807885113"
                    },
                    "checkinDate": "",
                    "checkoutDate": ""
                })
            }
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (LodgingReservationSchema);


/***/ }),

/***/ 2298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/styles/pages/Home.module.scss
var Home_module = __webpack_require__(256);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Faqs.js
var Faqs = __webpack_require__(4264);
// EXTERNAL MODULE: ./src/components/Reusable/Reusable.module.scss
var Reusable_module = __webpack_require__(8180);
var Reusable_module_default = /*#__PURE__*/__webpack_require__.n(Reusable_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/Reusable/AboutSection.js





const AboutSection = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "common_padding",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((Reusable_module_default()).about_sec_main, " row align-items-center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Reusable_module_default()).about_sec_main_left, " col-lg-5 col-md-12 col-sm-12"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "common_title",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Best Hotel in Shimla"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-capitalize",
                                    children: "The Twin Towers Hotel in Kufri"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "One of the best Luxury Hotel in Kufri, The Twin Towers Hotel, is located in the heart of town, amid the Himalayan foothills. It offers a beautiful retreat in a mountainous neighborhood, providing visitors with a tranquil, calm, and pleasant atmosphere for a soul-filling holiday. Being so near to nature offers a choice of activities that will nourish your spirit. It will undoubtedly assist you in unwinding while you participate in the most exciting activities with your loved ones at and around the resort. This is the best hotel in Shimla, Kufri for fun activities such as adventure sports, walks, and trails. Whether you're looking for an affordable hotel in Shimla or a budget hotel in Shimla, The Twin Towers Hotel is the perfect choice for your stay. Book your stay at one of the top 4-star hotels in Kufri with online hotel booking in Shimla for a memorable experience in Himachal."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/about-us",
                                    className: "secound_common_btn",
                                    children: "About Us"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Reusable_module_default()).about_sec_main_right, " col-lg-7 col-md-12 col-sm-12"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/about-section-img.png",
                            width: 758,
                            height: 408,
                            alt: "Hotel Twin Tower",
                            priority: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Reusable_module_default()).about_contact_no,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            href: "tel:9318192605",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        height: "24px",
                                        viewBox: "0 -960 960 960",
                                        width: "24px",
                                        fill: "#1A1A1A",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "+91 93181-92605"
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Reusable_AboutSection = (/*#__PURE__*/react.memo(AboutSection)); // <div className={`${styles.img_container} ${styles.first_img}`}>
 // <Image
 //     src="/images/about-sec-1.webp"
 //     alt="Hotel Twin Tower"
 //     width={280}
 //     height={328}
 //     sizes="(max-width: 767px) 200px, (max-width: 1024px) 280px, 328px"
 //     placeholder="blur"
 //     blurDataURL="https://www.success.com/wp-content/uploads/2023/12/istockphoto-1147544807-612x612-1.jpg"
 // />
 // </div>
 // <div className={`${styles.img_container} ${styles.centered_img}`}>
 // <Image
 //     src="/images/about-sec-2.webp"
 //     alt="Hotel Twin Tower Restaurant Image"
 //     width={280}
 //     height={328}
 //     sizes="(max-width: 767px) 200px, (max-width: 1024px) 280px, 328px"
 //     placeholder="blur"
 //     blurDataURL="https://www.success.com/wp-content/uploads/2023/12/istockphoto-1147544807-612x612-1.jpg"
 // />
 // </div>
 // <div className={`${styles.img_container} ${styles.last_img}`}>
 // <Image
 //     src="/images/about-sec-3.webp"
 //     alt="Hotel Twin Tower Room Image"
 //     width={280}
 //     height={328}
 //     sizes="(max-width: 767px) 200px, (max-width: 1024px) 280px, 328px"
 //     placeholder="blur"
 //     blurDataURL="https://www.success.com/wp-content/uploads/2023/12/istockphoto-1147544807-612x612-1.jpg"
 // />
 // </div>

;// CONCATENATED MODULE: ./src/components/Reusable/ContactLink.js





const ContactLink = /*#__PURE__*/ react.memo((param)=>/*#__PURE__*/ {
    let { phoneNumber , iconSrc  } = param;
    return (0,jsx_runtime.jsxs)((link_default()), {
        href: "tel:".concat(phoneNumber),
        className: (Reusable_module_default()).room_contact_no,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "icon_con",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "24px",
                    viewBox: "0 -960 960 960",
                    width: "24px",
                    fill: "#1A1A1A",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "m-0",
                children: phoneNumber
            })
        ]
    });
});
/* harmony default export */ var Reusable_ContactLink = (ContactLink);

// EXTERNAL MODULE: ./src/components/Schema/HotelSchema/breadcrumb.js
var breadcrumb = __webpack_require__(9881);
// EXTERNAL MODULE: ./src/components/Schema/HotelSchema/hotel-schema.js
var hotel_schema = __webpack_require__(1058);
// EXTERNAL MODULE: ./src/components/Schema/HotelSchema/local-business.js
var local_business = __webpack_require__(8360);
// EXTERNAL MODULE: ./src/components/Schema/HotelSchema/lodgingreservation.js
var lodgingreservation = __webpack_require__(6601);
// EXTERNAL MODULE: ./src/components/Search/SingleHotelsearchform.js
var SingleHotelsearchform = __webpack_require__(1178);
;// CONCATENATED MODULE: ./src/pages/index.js






const Slider = dynamic_default()(()=>__webpack_require__.e(/* import() */ 66).then(__webpack_require__.bind(__webpack_require__, 6066)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(6066)
            ]
    },
    ssr: false
});
const Instagallery = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(545), __webpack_require__.e(164)]).then(__webpack_require__.bind(__webpack_require__, 4164)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(4164)
            ]
    },
    ssr: false
});
const BestDeal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 383).then(__webpack_require__.bind(__webpack_require__, 9383)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9383)
            ]
    },
    ssr: false
});
const HomePageVideo = dynamic_default()(()=>__webpack_require__.e(/* import() */ 35).then(__webpack_require__.bind(__webpack_require__, 7035)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(7035)
            ]
    },
    ssr: false
});








var __N_SSG = true;
function Home(param) {
    let { Allrooms , Allblogs  } = param;
    const roomsSettings = {
        lazyLoad: "ondemand",
        dots: true,
        infinite: true,
        speed: 500,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    const bannersettings = {
        lazyLoad: "ondemand",
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false
    };
    const settings = {
        lazyLoad: "ondemand",
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const activities = [
        {
            title: "Sky Swinger",
            bgImage: "/images/sky-swinger.jpg",
            description: "Sky Swinger is a new way to experience the sky. As an aerial playground, Sky Swinger offers thrilling opportunities for people to experience the rush of adrenaline."
        },
        {
            title: "Go Kart",
            bgImage: "/images/karting-attra.jpg",
            description: "Go-karts are the ultimate way to channel your inner child. We know you've got the skills and the moves, but it's time to get out of your comfort zone with Go Karting."
        },
        {
            title: "Zip Line",
            bgImage: "/images/zip-line.webp",
            description: "Zipline offers a unique, exhilarating experience you'll never forget. Our expert instructors help participants feel secure during the flight."
        },
        {
            title: "Bungee Ejection",
            bgImage: "/images/bungee.jpg",
            description: " Bungee Injection is a new adventure activity that combines one of the most adrenaline-pumping experiences in the world with a fun, friendly environment."
        },
        {
            title: "Indoor activities",
            bgImage: "/images/outdoor.jpg",
            description: "At Adventure Resorts, we have a wide variety of indoor activities to keep you entertained. We have dashing cars, haunted house, 5D theater and much more. You will never feel bored."
        }
    ];
    const testimonial = {
        dots: true,
        infinite: true,
        speed: 1000,
        autoplay: true,
        // autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    };
    const testimonialData = [
        {
            userImage: "/images/user.jpg",
            userName: "Shri kant",
            place: "From India",
            description: "It was a great pleasure to stay at The Twin Towers Hotel. I have been there many times & always feel like just home. The service,staff are very professional ."
        },
        {
            userImage: "/images/user.jpg",
            userName: "Priyankona",
            place: "From India",
            description: "Great Service! Awesome food! Spacious & comfortable room with breathtaking view. Absolutely Genuine, friendly and caring staff. Hotel is situated at a great location with beautiful scenic views. Would love to visit again!"
        },
        {
            userImage: "/images/user.jpg",
            userName: "Hitesh Jain",
            place: "From India",
            description: "What a wonderful place it is. You can not get more fun anywhere else in this area. Clean, good food, good views, lots of fun activities."
        }
    ];
    const bannerData = [
        {
            // bgImage: "/images/home-banner.webp",
            bgImage: "/images/banners/monsoon-banner-1.webp",
            bgImageMobile: "/images/banners/monsoon-banner-mobile-1.webp",
            titleone: "Embrace the warmth and luxury at its finest",
            hyperlink: "#"
        },
        {
            // bgImage: "/images/adventure-banner.webp",
            bgImage: "/images/banners/monsoon-banner-2.webp",
            bgImageMobile: "/images/banners/monsoon-banner-mobile-2.webp",
            titleone: "A complete tourist destination",
            hyperlink: "https://adventureresortkufri.com/",
            target: "_blank"
        },
        {
            // bgImage: "/images/Gallery/res-banner3.jpg",
            bgImage: "/images/banners/winter-banner-3.webp",
            bgImageMobile: "/images/banners/winter-banner-3.webp",
            titleone: "Enjoy hearty meal in a calm and relaxing atmosphere.",
            hyperlink: "#"
        }
    ];
    const faqsData = [
        {
            id: 1,
            accordionQuestion: "What makes The Twin Towers Hotel the best hotel in Kufri?",
            accordionAnswer: "The Twin Towers Hotel in Kufri offers a tranquil and pleasant atmosphere in the heart of Kufri, amid the Himalayan foothills, making it the best luxury hotel in the area."
        },
        {
            id: 2,
            accordionQuestion: "Where is The Twin Towers Hotel located?",
            accordionAnswer: "The Twin Towers Hotel in Kufri is located in the heart of Shimla town, amid the picturesque Himalayan foothills."
        },
        {
            id: 3,
            accordionQuestion: "What activities are available around The Twin Towers Hotel in Kufri?",
            accordionAnswer: "The Twin Towers Hotel in Kufri offers various fun activities, including adventure sports, nature walks, and scenic trails."
        },
        {
            id: 4,
            accordionQuestion: "How can I book my stay at The Twin Towers Hotel in Kufri?",
            accordionAnswer: "You can book your stay at The Twin Towers Hotel in Kufri through online hotel booking platforms for a seamless and memorable experience in Shimla."
        },
        {
            id: 5,
            accordionQuestion: "Why should I choose The Twin Towers Hotel for my stay in Shimla?",
            accordionAnswer: "The Twin Towers Hotel provides a beautiful retreat with luxurious amenities, a serene atmosphere, and various fun activities, making it the perfect choice for your stay in Shimla."
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Best Hotel in Kufri | The Twin Towers Hotel in Shimla"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Welcome to The Twin Towers hotel in Shimla, the 4-star luxury best hotel in Kufri, Himachal. We offer luxury rooms, facilities, and affordable banquet halls for your stay in Kufri."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.hoteltwintowers.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://www.hoteltwintowers.com/images/hotel-twin-tower-featured2.jpg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "hotel in kufri himachal, online hotel booking in shimla, Luxury Hotel In Kufri, Shimla Best Hotel in Kufri, 4 star hotels in shimla, 4 star hotel in kufri, best hotel in shimla, affordable hotel in shimla, budget hotel in shimla, hotel in kufri shimla, top hotels in shimla, hotels in new Kufri"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        as: "image",
                        href: "/images/banners/monsoon-banner-1.webp",
                        type: "image/webp",
                        fetchpriority: "high"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preload",
                        as: "image",
                        href: "/images/banners/monsoon-banner-mobile-1.webp",
                        type: "image/webp",
                        fetchpriority: "high",
                        media: "(max-width: 767px)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                        ...bannersettings,
                        className: "banner_slider",
                        children: bannerData.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Home_module_default()).home_banner,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item.bgImage,
                                        alt: "Background Image",
                                        fill: true,
                                        style: {
                                            objectFit: "cover"
                                        },
                                        quality: 80,
                                        priority: index === 0,
                                        loading: index === 0 ? "eager" : "lazy",
                                        className: (Home_module_default()).home_banner_image,
                                        sizes: "(max-width: 768px) 100vw, 1920px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: item.bgImageMobile,
                                        alt: "Background Image",
                                        fill: true,
                                        style: {
                                            objectFit: "cover"
                                        },
                                        quality: 80,
                                        priority: index === 0,
                                        loading: index === 0 ? "eager" : "lazy",
                                        className: (Home_module_default()).mobiel_home_banner_image,
                                        sizes: "(max-width: 768px) 100vw, 100vw"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Home_module_default()).banner_text,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((Home_module_default()).banner_text_con, " common_title"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    children: item.titleone
                                                })
                                            })
                                        })
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleHotelsearchform/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Reusable_AboutSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((Home_module_default()).booking_sec, " common_padding pb-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BestDeal, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                            ...roomsSettings,
                            className: "rooms_slider",
                            children: Allrooms.map((room)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat((Home_module_default()).room_con, " row common_padding"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((Home_module_default()).room_left, " col-lg-4 common_title"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: room.roomName
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: room.roomDesc
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Reusable_ContactLink, {
                                                        phoneNumber: "+91 93181-92605",
                                                        iconSrc: "/icons/call-black.svg"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat((Home_module_default()).room_center, " col-lg-4 first-order-mobile"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: room.roomsImage,
                                                    width: 410,
                                                    height: 360,
                                                    alt: room.roomName + " Image",
                                                    priority: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((Home_module_default()).room_right, " col-lg-4"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Home_module_default()).room_right_bottom,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat((Home_module_default()).room_right_image, " icon_con"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "/icons/key.svg",
                                                                    height: 21,
                                                                    width: 21,
                                                                    alt: "key-icon"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Home_module_default()).right_bottom_text,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "Smart Key"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Smart key card that enables you to access your room electronically without ever having to worry about lost keys again!"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Home_module_default()).room_right_bottom,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "icon_con",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "/icons/valley.svg",
                                                                    height: 21,
                                                                    width: 21,
                                                                    alt: "valley-icon"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Home_module_default()).right_bottom_text,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "Valley View"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "Nestled among the Himalayas, our hotel offers views of breathtaking valleys and mountains."
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Home_module_default()).room_right_bottom,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "icon_con",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "/icons/wifi.svg",
                                                                    height: 21,
                                                                    width: 21,
                                                                    alt: "wifi-icon"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: (Home_module_default()).right_bottom_text,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "Home Wi-Fi"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "We provide free wifi with a high-speed connection, so you can work on the go with all the amenities of home"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, room.slug))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((Home_module_default()).button_sec, " col-md-12 text-center"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/hotel-room-in-shimla",
                                className: "secound_common_btn",
                                children: "View All Rooms"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageVideo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((Home_module_default()).hall_sec, " common_padding pb-0"),
                id: "events",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "common_title text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "We does Fulfill your all needs"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "".concat((Home_module_default()).image_sec, " row"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col col-12 col-sm-12 col-md-6 col-lg-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Home_module_default()).image_sec_left,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/wedding-hall.webp",
                                                alt: "destination wedding in shimla",
                                                fill: true,
                                                style: {
                                                    objectFit: "cover"
                                                },
                                                quality: 100,
                                                sizes: "(max-width: 768px) 100vw, 1920px"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "".concat((Home_module_default()).conference_btn, " common_btn"),
                                                href: "/contact-us",
                                                children: "Wedding"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Home_module_default()).image_overlay,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "WEDDING"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Our banquet halls are equipped with state-of-the-art technologies, including cutting edge lighting, audio-visual equipment and exquisite d\xe9cor that can be customized to match your dream event. We also offer a variety of amenities with our packages, such as in-house catering, in-room dining and more."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        className: "secound_common_btn",
                                                        href: "/banquet-halls-in-shimla",
                                                        children: "ENQUIRE NOW"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col col-12 col-sm-12 col-md-6 col-lg-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Home_module_default()).image_sec_left,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/images/cooperate-event.webp",
                                                alt: "conference hall in shimla",
                                                fill: true,
                                                style: {
                                                    objectFit: "cover"
                                                },
                                                quality: 100,
                                                sizes: "(max-width: 768px) 100vw, 1920px"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "".concat((Home_module_default()).conference_btn, " common_btn"),
                                                href: "/contact-us",
                                                children: "Corporate Events"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Home_module_default()).image_overlay,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "CORPORATE EVENTS"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "We are home to one of the largest event spaces in Hiamchal, Our auditorium is a perfect space for hosting conferences, exhibitions and other large meetings. Let us help you bring your idea to life with our state of the art facilities & services with plenty of parking spaces for cars, buses and vans, etc. Our team is dedicated to making your event a success."
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        className: "secound_common_btn",
                                                        href: "/conference-hall",
                                                        children: "ENQUIRE NOW"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((Home_module_default()).activities_sec, " common_padding pb-0"),
                id: "activity_scroll",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "common_title text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "ACTIVITIES"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Explore our Adventure Activities"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Home_module_default()).activities_slider,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                                    ...settings,
                                    className: "activity_slider",
                                    ariaHidden: false,
                                    children: activities.map((activity, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Home_module_default()).activity_child,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (Home_module_default()).activity_bg_image,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: activity.bgImage,
                                                        fill: true,
                                                        alt: activity.title,
                                                        sizes: "(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 1000px"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: activity.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Home_module_default()).activity_overlay,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: activity.description
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                children: [
                                                                    "Click Here to: ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "https://www.adventureresortkufri.com/rides-and-activities",
                                                                        target: "_blank",
                                                                        children: "Buy Ticket"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, index))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Home_module_default()).explore_btn,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Get exclusive 10% OFF on all adventure activities at Adventure Resorts, ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "https://www.adventureresortkufri.com",
                                                    target: "_blank",
                                                    children: "Buy Ticket"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((Home_module_default()).blogs_sec, " common_padding pt-0"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "common_title text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Blogs"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Read our Latest Blogs"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).blogs,
                            children: Allblogs.slice(0, 3).map((blog)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: "/blogs/".concat(blog.slug),
                                    className: "".concat((Home_module_default()).single_blog_parent),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Home_module_default()).all_blog_image,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: blog.bgImage,
                                                alt: blog.title,
                                                width: 412,
                                                height: 250,
                                                style: {
                                                    objectFit: "cover"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((Home_module_default()).all_blog_content, " d-flex"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (Home_module_default()).blog_date,
                                                        children: blog.date
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: (Home_module_default()).blog_title,
                                                        children: blog.blog_title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: blog.shortDescription
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, blog.slug))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((Home_module_default()).button_sec, " col-md-12 text-center"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                className: "secound_common_btn",
                                href: "/blogs",
                                children: "View All Blogs"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "".concat((Home_module_default()).help_sec),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat((Home_module_default()).help_sec_child, " row align-items-center"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-8 common_title",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Need any help? Please contact with Us!"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                    href: "tel:9318192605",
                                    className: "icon_text",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "icon_con black_icon_con",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "24px",
                                                viewBox: "0 -960 960 960",
                                                width: "24px",
                                                fill: "#1A1A1A",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M798-120q-125 0-247-54.5T329-329Q229-429 174.5-551T120-798q0-18 12-30t30-12h162q14 0 25 9.5t13 22.5l26 140q2 16-1 27t-11 19l-97 98q20 37 47.5 71.5T387-386q31 31 65 57.5t72 48.5l94-94q9-9 23.5-13.5T670-390l138 28q14 4 23 14.5t9 23.5v162q0 18-12 30t-30 12ZM241-600l66-66-17-94h-89q5 41 14 81t26 79Zm358 358q39 17 79.5 27t81.5 13v-88l-94-19-67 67ZM241-600Zm358 358Z"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "",
                                            children: " +91 93181-92605"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "".concat((Home_module_default()).testimonial_sec, " common_padding"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Home_module_default()).background_image,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/testimonial-bg.jpg",
                            alt: "Testimonial Background",
                            fill: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "common_title text-center ",
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "text-white",
                                        children: "testimonials"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "What Our Clients Say"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                                ...testimonial,
                                className: "testi_slider",
                                children: testimonialData.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((Home_module_default()).testimonial),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row justify-content-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat((Home_module_default()).testi_right, " col-md-6 col-sm-12 common_title"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: item.description
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        children: item.place
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: item.userName
                                                    })
                                                ]
                                            })
                                        })
                                    }, index))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "common_padding",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "hotel_page_hotel_haeding mb-2 text-center",
                            children: "FAQs"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Faqs/* default */.Z, {
                            faqsData: faqsData
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Instagallery, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hotel_schema/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(local_business/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lodgingreservation/* default */.Z, {})
        ]
    });
}
{}// import SingleHotelsearchform from '../components/Search/SingleHotelsearchform';
// import PricePopup from '../components/pricePopup';
// import ParamsForm from '../components/Search/ParamsForm';
//  <section className={styles.banner_video}>
//         <div id='player'></div>
//   </section>
//  <section className={styles.banner_video}>
//         <iframe src='https://www.youtube.com/embed/keTV9UFHNpA?controls=0&autoplay=1&mute=1&rel=0&showinfo=0'
//           frameBorder='0'
//           allow='autoplay; encrypted-media'
//           allowFullScreen
//           width="100%"
//           height="100%"
//           title='video'
//           className={styles.video_bg}
//         />
// </section>
// https://www.youtube.com/embed/keTV9UFHNpA?controls=0&autoplay=1&mute=1&rel=0&showinfo=0&modestbranding=0&loop=1
{}{}{}

/***/ }),

/***/ 8180:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"about_sec_main":"Reusable_about_sec_main__vIQBV","about_sec_main_left":"Reusable_about_sec_main_left__sW_EQ","about_sec_main_right":"Reusable_about_sec_main_right__aM1fS","about_contact_no":"Reusable_about_contact_no__A0_cZ","room_contact_no":"Reusable_room_contact_no__cJ87Q"};

/***/ }),

/***/ 256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"home_banner":"Home_home_banner__kArgw","banner_text":"Home_banner_text__nh89y","banner_text_con":"Home_banner_text_con__Jogsr","videobanner":"Home_videobanner__Tkj0g","video_bg":"Home_video_bg__qf_ah","hyperlink_button":"Home_hyperlink_button__y667M","single_hotel_search_form_container":"Home_single_hotel_search_form_container__HqA9G","home_banner_image":"Home_home_banner_image__t3akK","mobiel_home_banner_image":"Home_mobiel_home_banner_image__GUcAt","banner_video":"Home_banner_video__SddjS","banner_slider_wrapper":"Home_banner_slider_wrapper__UTLDE","slick_slide":"Home_slick_slide__qJU2c","slick_slide_image":"Home_slick_slide_image__hhGEg","slick_slide_text":"Home_slick_slide_text__O67as","slick-prev":"Home_slick-prev__4656Z","slick-next":"Home_slick-next__1kKST","booking_sec":"Home_booking_sec__HpePc","booking_cont":"Home_booking_cont__fMu_2","booking_col":"Home_booking_col__dOC3d","button_col":"Home_button_col__bFrbD","check_now_btn":"Home_check_now_btn__mHeYn","room_con":"Home_room_con__yiOP5","room_left":"Home_room_left__idckC","room_center":"Home_room_center__k4vSt","room_right":"Home_room_right__erFsr","room_right_bottom":"Home_room_right_bottom__kmBTr","right_bottom_text":"Home_right_bottom_text__mvi4g","button_sec":"Home_button_sec__MdG6_","hall_sec":"Home_hall_sec__fTUX9","image_sec":"Home_image_sec__tFNpX","image_sec_left":"Home_image_sec_left__werHr","conference_btn":"Home_conference_btn__XZpN3","image_overlay":"Home_image_overlay__Cp9qu","activities_sec":"Home_activities_sec__ARKi1","activities_slider":"Home_activities_slider___q9lq","activity_child":"Home_activity_child__uN8Qi","activity_bg_image":"Home_activity_bg_image__ugYWi","activity_overlay":"Home_activity_overlay__t5zMy","explore_btn":"Home_explore_btn__6MzO_","help_sec":"Home_help_sec__7Rilk","help_sec_child":"Home_help_sec_child__SIt9r","testimonial_sec":"Home_testimonial_sec__B_HiR","background_image":"Home_background_image__Vo5NE","testimonial":"Home_testimonial__QHdb5","testi_left":"Home_testi_left__0C7fk","testi_right":"Home_testi_right__QAzWv","blogs_sec":"Home_blogs_sec__IzPka","blogs":"Home_blogs__oH2o4","single_blog_parent":"Home_single_blog_parent__Zq2Tg","all_blog_image":"Home_all_blog_image___i_Z2","all_blog_content":"Home_all_blog_content__ZBhKT","privacy_policy":"Home_privacy_policy__Z3_uX"};

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7645)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [661,960,178,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);